<p-dialog [(visible)]="openDialog" [modal]="true" [style]="{'width': width + 'px', 'height': height + 'px'}"
  [baseZIndex]="12000" appendTo="body" (onHide)="confirmNoClick(true)">
  <p-header>
    {{header}}
  </p-header>
  <div class="m-b-12" [ngStyle]="{'height' : scrollable ? (dialogHeight + 'px') : 'inherit'}"
    [ngClass]="{'overflow' : scrollable}">
    <ng-content></ng-content>
  </div>
  <p-footer>
    <div class="text-right">
      <button pButton type="button" class="m-r-12"  label="{{yesText | translate}}" [disabled]="disableButton"
         (click)="confirmYesClick()">
      </button>
      <button pButton type="button" class="p-button-tertiary"  label="{{noText | translate}}" [disabled]="disableButton"
         (click)="confirmNoClick(false)">
      </button>
    </div>
  </p-footer>
</p-dialog>